import { type Permission } from "@relay/permissionBasedNavigation_Query.graphql";
import { useCheckPermissions } from "../use-check-permissions";

export const useHasPermissions = (necessaryPermissions: Permission[] | "onlyOwnerOfRoot") => {
	const checkPermissions = useCheckPermissions();
	return checkPermissions(necessaryPermissions);
};
